import { ServiceSellType } from "../util/enums";
import { Base } from "./base";
import { PriceGroup } from "./price.group";

export interface Service extends Base {
  buyAccount?: string;
  buyDescription?: string;
  buyFlatFee?: string;
  buyHalfHourFee?: string;
  buyM3Fee?: string;
  buyStatus?: string;
  buyTaxRate?: string;
  buyType?: string;
  code?: string;
  sellAccount?: string;
  sellDescription?: string;
  sellFlatFee?: number;
  sellHalfHourFee?: number;
  sellHourlyFee?: number;
  sellM3Fee?: number;
  sellStatus?: string;
  sellTaxRate?: number;
  sellType?: string;

  status?: string;
  defaultFee?: string;

  groups?: PriceGroup[];
  margin?: number;
}

export interface ChargeOptions {
  Fee: string;
  Flat: string;
  Hourly: string;
  "Half Hour": string;
}

export enum ChargeOptionsEnum {
  Fee = "Fee",
  Flat = "Flat",
  Hourly = "Hourly",
  "Half Hour" = "Half Hour",
}

export interface IValidateServiceTemplate {
  code: string;
  description: string;
  sellType: ServiceSellType;
  m3Fee: number;
  flatFee: number;
  hourlyFee: number;
  halfHourFee: number;
}

export interface IUploadCentreCreateServiceList extends IValidateServiceTemplate {
  sellDescription: string;
  sellM3Fee: number;
  sellFlatFee: number;
  sellHourlyFee: number;
  sellHalfHourFee: number;
  companyId: number;
}
